import { useConfigService } from '@thd-nucleus/experience-context';
import { FEATURE_SWITCH_NAMES } from '../utils/consts';

interface IEnableReloadProp {
  isB2B: boolean;
}

export const useDisableCheckBalanceAndReload = ({ isB2B }: IEnableReloadProp) => {
  const isDisableCheckBalance = !!useConfigService(
    FEATURE_SWITCH_NAMES.DISABLE_GIFT_CARD_CHECK_BALANCE_AND_RELOAD
  );
  // This FS is for disabling Reload for both Cards&Account and Gift Card Experiences
  const isDisableReloadUI = !!useConfigService(FEATURE_SWITCH_NAMES.DISABLE_GIFT_CARD_RELOAD);
  // This FS is for enabling Reload for B2c in Cards&Account Experience
  const isEnableReloadB2cFS = !!useConfigService(FEATURE_SWITCH_NAMES.enableReloadB2c);
  // For B2c, reload functionality is disabled if reload FS is disabled across experiences or disabled for B2c
  // If check balance is disabled, reload will also be disabled
  const isDisableReload = isDisableCheckBalance
    || (isB2B ? isDisableReloadUI : isDisableReloadUI || !isEnableReloadB2cFS);

  return { isDisableCheckBalance, isDisableReload };
};
